<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Report Balance Sheet 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="process()">
                    <i class="fa fa-play"></i>
                    Process
                </button>
                <button class="btn btn-primary mr-1" @click="print()">
                    <i class="fa fa-print"></i>
                    print
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="4">
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error"></b-form-select>
                    </b-input-group>
                </b-col>
                <b-col lg="4">
                  <b-input-group >
                        <b-input-group-prepend><span class="pt-2 mr-2">Periode Date</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" type="date" readonly></b-form-input>
                        <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl2.$error"></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row >
            <div class="report-wraper">
                <table  style="width: 100%;">
                    <thead>
                        <tr>
                        <th >AKTIVA</th>
                        <th v-if="filter.tglbulanini" style="text-align:right" width="140px">{{filter.tglbulanini | moment("MMMYYYY")}}</th>
                        <th v-else style="text-align:right" width="140px">Month to date</th>
                        <th v-if="filter.tgltahunlalu" style="text-align:right" width="140px">{{filter.tgltahunlalu | moment("MMM YYYY")}}</th>
                        <th v-else style="text-align:right" width="140px">Begining Year</th>
                        <th width="45px"></th>
                        <th >PASIVA</th>
                        <th v-if="filter.tglbulanini" style="text-align:right" width="140px">{{filter.tglbulanini | moment("MMMYYYY")}}</th>
                        <th v-else style="text-align:right" width="140px">Month to date</th>
                        <th v-if="filter.tgltahunlalu" style="text-align:right" width="140px">{{filter.tgltahunlalu | moment("MMM YYYY")}}</th>
                        <th v-else style="text-align:right" width="140px">Begining Year</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in rptLines" :key="row.idrowunik">
                        <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                        <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillSdAkhir(row)" style="text-align:right">{{row.sdakhir | numFormat("0,0.00") }}</td>
                        <td v-else ></td>
                        <td :class="row.kelas" v-if="row.kode || row.rumus" @click="drillSdAwal(row)" style="text-align:right">{{row.sdawal | numFormat("0,0.00") }}</td>
                        <td v-else ></td>
                        <td></td>
                        <td :class="row.kelas2"><span v-html="row.uraianhtm2"></span></td>
                        <td :class="row.kelas2" v-if="row.kode2 || row.rumus2" @click="drillSdAkhir2(row)" style="text-align:right">{{row.sdakhir2 | numFormat("0,0.00") }}</td>
                        <td v-else ></td>
                        <td :class="row.kelas2" v-if="row.kode2 || row.rumus2" @click="drillSdAwal2(row)" style="text-align:right">{{row.sdawal2 | numFormat("0,0.00") }}</td>
                        <td v-else ></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="drillConfirmation" scrollable size="md" title="Drilldown Confirmation" hide-footer>
            <span>Show Detail value of <strong>{{drillSrc.uraian}}</strong> ?</span>
            <b-form-checkbox :value="1" :unchecked-value="0" v-model="drillNewtab" class="mt-1 ml-2">Open New Tab</b-form-checkbox>
            <b-row class="justify-content-center mt-1">
                <b-button variant="primary" class="ml-2" @click="drillAction('GL')" > Show in GL</b-button>
                <b-button variant="primary" class="ml-2" @click="drillAction('TB')" > Show in TB</b-button>
                <b-button variant="primary" class="ml-2" @click="drillAction('MODUL')" v-if="(drillModul)"> Show in subModul</b-button>
                <b-button variant="secondary" class="ml-2" @click="drillConfirmation=false" > Cancel</b-button>
            </b-row>
        </b-modal>

    </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            table-layout: auto;
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import bs from "../../apis/bs";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filter: {layout:'',tgl1:'',tgl2:''},
      isLoading: false,
      layouts:[],
      arPostgroups:[],
      apPostgroups:[],
      advancegroups:[],
      inventorygroups:[],
      horizontal: true,
      reportUrl: null,
      showReport:false,
      rptLines:[],
      drillConfirmation:false,
      drillSrc:{}, drillCol:'', 
      drillModul:'',drillNewtab:1
    };
  },
components: { Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
watch:{
      layout: async function(newval) {
          this.rptLines= await bs.layout({layout : newval});
      }
  },
created: async function (){
    const [layouts,arPostgroups,apPostgroups,advancegroups,inventorygroups] = await Promise.all([bs.layout_combo(),bs.arPostgroup(),bs.apPostgroup(),bs.advancegroup(),bs.inventorygroup()]) ;  
    this.layouts=layouts;
    this.arPostgroups=arPostgroups;
    this.apPostgroups=apPostgroups;
    this.advancegroups=advancegroups;
    this.inventorygroups=inventorygroups;
    var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
    this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    this.filter.tgl2=tgl2.format('YYYY-MM-DD');
    this.filter.tgltahunlalu= tgl1.subtract(1, 'day');
    // this.filter.tglbulanlalu= moment(this.filter.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
        this.filter.tglbulanlalu=  moment(`${tgl2.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    this.filter.tglbulanini= tgl2;

  },
methods:{
    updateTgl1: function() {
        var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
        var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
        this.filter.tgl1=tgl1.format('YYYY-MM-DD');
        this.filter.tgltahunlalu= tgl1.subtract(1, 'day');
        // this.filter.tglbulanlalu= moment(this.filter.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
        this.filter.tglbulanlalu=  moment(`${tgl2.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.filter.tglbulanini= tgl2;
    },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                // Test Hak akses SUDAH BENAR,  jika api controller didaftar di sys_api
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');

                this.rptLines= await bs.rpt(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
        }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                this.showReport=true;
                this.reportUrl= await bs.rptprint(model);
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                const response = await bs.rptexport(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    cekModule: function(kodeacc) {
        this.drillModul='';
        // if (kodeacc.startsWith('140')) {
        //     this.drillModul='receivable.araging';
        // } else if (kodeacc.startsWith('141')) {
        //     this.drillModul='advance.advaging';
        // } else if (kodeacc.startsWith('142')) {
        //     this.drillModul='accounting.loanaraging';
        // } else if (kodeacc.startsWith('150')) {
        //     this.drillModul='logistic.rptbalance';
        // } else if (kodeacc.startsWith('210')) {
        //     this.drillModul='payable.apsummary';
        // }    
        const inventory = this.inventorygroups.find(item => item.kodeacc==kodeacc);
        if (inventory) {
            this.drillModul='logistic.rptbalance';
            return;
        }
        const advance = this.advancegroups.find(item => item.advAcc==kodeacc);
        if (advance) {
            this.drillModul='advance.advaging';
            return;
        }
        const ar = this.arPostgroups.find(item => item.kodeacc==kodeacc);
        if (ar) {
            this.drillModul='receivable.araging';
            return;
        }
        const ap = this.apPostgroups.find(item => item.kodeacc==kodeacc);
        if (ap) {
            this.drillModul='payable.apsummary';
            return;
        }
    },
    drillSdAkhir: function(data){
        if (data.kode) {
            this.cekModule(data.kode);
            this.drillSrc=data;
            this.drillCol='sdAkhir';
            this.drillConfirmation=true;
        }
    },
    drillSdAwal: function(data){
        if (data.kode) {
            this.cekModule(data.kode);
            this.drillSrc=data;
            this.drillCol='sdAwal';
            this.drillConfirmation=true;
        }
    },
    drillSdAkhir2: function(data){
        if (data.kode2) {
            this.cekModule(data.kode);
            this.drillSrc=data;
            this.drillCol='sdAkhir2';
            this.drillConfirmation=true;
        }
    },
    drillSdAwal2: function(data){
        if (data.kode2) {
            this.cekModule(data.kode);
            this.drillSrc=data;
            this.drillCol='sdAwal2';
            this.drillConfirmation=true;
        }
    },

    drillAction(drillTarget){
        let drillRoute;
        switch (drillTarget) {
            case 'TB':
                if (this.drillCol=='sdAwal') {
                    drillRoute= {name :'accounting.tb', params: { kodeaw: this.drillSrc.kode, tgl1:`${this.filter.tgltahunlalu.format('YYYY')}-01-01`, tgl2: this.filter.tgltahunlalu.format('YYYY-MM-DD')}}
                } else if (this.drillCol=='sdAkhir') {
                    var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                    drillRoute= {name :'accounting.tb', params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: this.filter.tgl2}};
                } else if (this.drillCol=='sdAwal2') {
                    drillRoute = {name :'accounting.tb', params: { kodeaw: data.kode2, tgl1:`${this.filter.tgltahunlalu.format('YYYY')}-01-01`, tgl2: this.filter.tgltahunlalu.format('YYYY-MM-DD')}}
                } else if (this.drillCol=='sdAkhir2') {
                    var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                    drillRoute = {name :'accounting.tb', params: { kodeaw: data.kode2, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: this.filter.tgl2}}
                }                    
                break;
        
            case 'MODUL':
                if (this.drillCol=='sdAwal') {
                    drillRoute= {name :this.drillModul, params: { kodeaw: this.drillSrc.kode, tgl1:`${this.filter.tgltahunlalu.format('YYYY')}-01-01`, tgl2: this.filter.tgltahunlalu.format('YYYY-MM-DD')}};
                } else if (this.drillCol=='sdAkhir') {
                    var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                    drillRoute = {name : this.drillModul, params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: this.filter.tgl2}};
                } else if (this.drillCol=='sdAwal2') {
                    drillRoute = {name :'accounting.gl', params: { kodeaw: data.kode2, tgl1:`${this.filter.tgltahunlalu.format('YYYY')}-01-01`, tgl2: this.filter.tgltahunlalu.format('YYYY-MM-DD')}}
                } else if (this.drillCol=='sdAkhir2') {
                    var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                    drillRoute = {name :this.drillModul, params: { kodeaw: data.kode2, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: this.filter.tgl2}}
                }    
                
                break;
        
            default:
                if (this.drillCol=='sdAwal') {
                    drillRoute= {name :'accounting.gl', params: { kodeaw: this.drillSrc.kode, tgl1:`${this.filter.tgltahunlalu.format('YYYY')}-01-01`, tgl2: this.filter.tgltahunlalu.format('YYYY-MM-DD')}}
                } else if (this.drillCol=='sdAkhir') {
                    var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                    drillRoute= {name :'accounting.gl', params: { kodeaw: this.drillSrc.kode, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: this.filter.tgl2}};
                } else if (this.drillCol=='sdAwal2') {
                    drillRoute = {name :'accounting.gl', params: { kodeaw: data.kode2, tgl1:`${this.filter.tgltahunlalu.format('YYYY')}-01-01`, tgl2: this.filter.tgltahunlalu.format('YYYY-MM-DD')}}
                } else if (this.drillCol=='sdAkhir2') {
                    var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
                    drillRoute = {name :'accounting.gl', params: { kodeaw: data.kode2, tgl1:`${tgl2.format('YYYY')}-01-01`, tgl2: this.filter.tgl2}}
                }    
                break;
        }
        if (drillRoute) {
            if (this.drillNewtab==1) {
                const routeData = router.resolve(drillRoute);
                window.open(routeData.href, '_blank');
            } else {
                router.push(drillRoute);                
            }
        }
    },
    close(){
      router.push("/accounting/home");
    }
  }
};
</script>
